import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from '../uitk-expando.css';

var getClassNameList = classNames.bind(styles);
/**
 * This is a simple expander that when clicked, will show more text or other
 * children. Makes use of inversion of control.
 * We make use of a description list:
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dl}
 * Accessibility:
 * @see {@link http://wwwexpediacom.a11y-demos-web.us-west-2.test.expedia.com/pages/components/toggles}
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function UitkExpandoList(_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    var cssClassNames = getClassNameList('uitk-expando-list', className);
    return (React.createElement("section", __assign({ className: cssClassNames }, props), children));
}
UitkExpandoList.displayName = 'UitkExpandoList';

export { UitkExpandoList };
